import React from 'react';
import PropTypes from 'prop-types';
import Draggable from './Draggable';
import css from '../manual-modal.module.css';
/**
 * @abstract
 */
export default class AbstractHover extends React.Component {
    static MOBILE_WIDTH = 600;
    static MIN_WIDTH_POPUP = 300;
    static TOP_POPUP_MOBILE = 120;
    static TOP_POPUP_DESKTOP = 240;

    /**
     * @abstract
     */
    renderContent() {
        throw new Error('AbstractHover/renderContent must be overridden');
    }

    renderTitle() {
        return this.props.zone.name;
    }

    className() {
        return 'zone-info';
    }

    draggableProps() {
        return {};
    }

    __renderContent() {
        return (
            <div className={`${css['hovered-zone']} dialog ${this.className()}`}>
                <div className="dialog-header">{this.renderTitle()}</div>
                <div className="dialog-body modal-popup">{this.renderContent()}</div>
            </div>
        );
    }

    render() {
        const content = this.__renderContent();
        let screenWidth = window.innerWidth;

        const position = {
            x: Number(this.props.mouseX) + AbstractHover.MIN_WIDTH_POPUP > screenWidth ? screenWidth - AbstractHover.MIN_WIDTH_POPUP : this.props.mouseX,
            y: Number(this.props.mouseY) + AbstractHover.MIN_WIDTH_POPUP > screenWidth ? screenWidth - AbstractHover.MIN_WIDTH_POPUP : this.props.mouseY
        };

        // If mouse positions are given render draggable
        if (!isNaN(this.props.mouseX) && !isNaN(this.props.mouseY)) {
            return <Draggable position={position}>{content}</Draggable>;
        }

        return content;
    }
}

AbstractHover.propTypes = {
    zone: PropTypes.object.isRequired,
    mouseX: PropTypes.number,
    mouseY: PropTypes.number
};
